<script setup lang="ts">
import { PanelLeft } from '@lucide/vue'
import type { HTMLAttributes } from 'vue'
import { cn } from '../../../lib/utils'
import { Button, type ButtonVariants } from '../button'
import { useSidebar } from './utils'

/*
 * `variant` and `size` are pass-through so a caller can sit this beside other buttons and have it look
 * like one of them — the portal's header puts it next to Search and Log out. The defaults are the
 * shadcn recipe's own, so anywhere that does not ask is unchanged.
 */
const props = withDefaults(
    defineProps<{
        class?: HTMLAttributes['class']
        variant?: ButtonVariants['variant']
        size?: ButtonVariants['size']
    }>(),
    { variant: 'ghost', size: 'icon-sm' },
)

const { toggleSidebar } = useSidebar()
</script>

<template>
  <Button
    data-sidebar="trigger"
    data-slot="sidebar-trigger"
    :variant="props.variant"
    :size="props.size"
    :class="cn('', props.class)"
    @click="toggleSidebar"
  >
    <PanelLeft class="cn-rtl-flip" />
    <span class="sr-only">Toggle Sidebar</span>
  </Button>
</template>
